import Vue from "vue";
import Component from "vue-class-component";

@Component()
export default class QueryStringManager extends Vue {
  get searchFromQueryString() {
    return new URLSearchParams(window.location.search).get("src");
  }
}
